'use client';

import { c as _c } from "react/compiler-runtime";
import { type OfferingOptionGroupFieldsFragment, RsGroupCostType } from '@/modules/__generated__/graphql/switchboard-generated';
import { buildServiceMetrics, buildServiceValues, computeOptionGroupHeaderPrices, getBillingCycleValue, getCostType, getCurrency, resolveAddOnDisplayPrice } from '@/modules/service-purchase/lib/utils';
import { useAllOptionGroups, useComputedTiers, useSelectedTier, useServiceOffering, useServicePurchaseActions, useServicePurchaseState } from '@/modules/service-purchase/providers/service-purchase-store-provider';
import { CatalogStatus } from '@/modules/service-purchase/types';
import { ServiceCatalogBody, ServiceCatalogHeader, ServiceCatalogRoot, ServiceCatalogRow } from '../..';
interface OptionGroupSectionProps {
  section: OfferingOptionGroupFieldsFragment;
  setupDiscountedPrices: Record<string, number | null>;
}
function OptionGroupSection(t0) {
  const $ = _c(59);
  const {
    section,
    setupDiscountedPrices
  } = t0;
  const servicesData = useServiceOffering();
  const tier = useSelectedTier();
  const tiers = useComputedTiers();
  const {
    setOptionGroupSelected
  } = useServicePurchaseActions();
  const storeOptionGroups = useAllOptionGroups();
  const {
    selectedBillingCycle: billingPeriod
  } = useServicePurchaseState();
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  if ($[0] !== billingPeriod || $[1] !== section || $[2] !== servicesData.services || $[3] !== setOptionGroupSelected || $[4] !== setupDiscountedPrices || $[5] !== storeOptionGroups || $[6] !== tier || $[7] !== tiers) {
    let t4;
    if ($[13] !== section.id) {
      t4 = s => s.optionGroupId === section.id;
      $[13] = section.id;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    const rowBody = servicesData.services.filter(t4);
    let t5;
    if ($[15] !== billingPeriod || $[16] !== section || $[17] !== tier) {
      t5 = section.isAddOn ? resolveAddOnDisplayPrice(section, tier.id, billingPeriod) : null;
      $[15] = billingPeriod;
      $[16] = section;
      $[17] = tier;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    const addOnDisplayPrice = t5;
    let t6;
    if ($[19] !== billingPeriod || $[20] !== section || $[21] !== tiers) {
      t6 = computeOptionGroupHeaderPrices(section, tiers, billingPeriod);
      $[19] = billingPeriod;
      $[20] = section;
      $[21] = tiers;
      $[22] = t6;
    } else {
      t6 = $[22];
    }
    const perTierPrices = t6;
    let t7;
    if ($[23] !== section.id || $[24] !== storeOptionGroups) {
      t7 = storeOptionGroups.find(og => og.id === section.id)?.isSelected ?? false;
      $[23] = section.id;
      $[24] = storeOptionGroups;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    const isAddOnSelected = t7;
    const groupSetupPrice = section.isAddOn && section.standalonePricing?.setupCost?.amount != null ? Number(section.standalonePricing.setupCost.amount) : undefined;
    T1 = ServiceCatalogRoot;
    t2 = !section.isAddOn || isAddOnSelected;
    const t8 = section.name;
    const t9 = section.isAddOn ? CatalogStatus.Optional : undefined;
    const t10 = section.isAddOn;
    const t11 = section.name;
    let t12;
    if ($[26] !== section.id || $[27] !== section.isAddOn || $[28] !== setOptionGroupSelected) {
      t12 = section.isAddOn ? enabled => {
        setOptionGroupSelected(section.id, enabled);
      } : undefined;
      $[26] = section.id;
      $[27] = section.isAddOn;
      $[28] = setOptionGroupSelected;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    let t13;
    if ($[30] !== addOnDisplayPrice?.basePrice || $[31] !== section) {
      t13 = section.isAddOn ? addOnDisplayPrice?.basePrice : getBillingCycleValue(section);
      $[30] = addOnDisplayPrice?.basePrice;
      $[31] = section;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    const t14 = section.isAddOn ? addOnDisplayPrice?.discountedPrice : section.costType === RsGroupCostType.Setup && setupDiscountedPrices[section.id] != null && setupDiscountedPrices[section.id] !== section.price ? setupDiscountedPrices[section.id] : undefined;
    let t15;
    if ($[33] !== section) {
      t15 = getCurrency(section);
      $[33] = section;
      $[34] = t15;
    } else {
      t15 = $[34];
    }
    let t16;
    if ($[35] !== section) {
      t16 = getCostType(section);
      $[35] = section;
      $[36] = t16;
    } else {
      t16 = $[36];
    }
    if ($[37] !== groupSetupPrice || $[38] !== isAddOnSelected || $[39] !== perTierPrices || $[40] !== section.isAddOn || $[41] !== section.name || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t16 || $[47] !== t9) {
      t3 = <ServiceCatalogHeader title={t8} badge={t9} hasToggle={t10} toggleLabel={t11} toggleEnabled={isAddOnSelected} onToggleChange={t12} groupPrice={t13} groupDiscountedPrice={t14} groupCurrency={t15} groupCostType={t16} perTierPrices={perTierPrices} isAddOn={section.isAddOn} groupSetupPrice={groupSetupPrice} />;
      $[37] = groupSetupPrice;
      $[38] = isAddOnSelected;
      $[39] = perTierPrices;
      $[40] = section.isAddOn;
      $[41] = section.name;
      $[42] = t12;
      $[43] = t13;
      $[44] = t14;
      $[45] = t15;
      $[46] = t16;
      $[47] = t9;
      $[48] = t3;
    } else {
      t3 = $[48];
    }
    T0 = ServiceCatalogBody;
    let t17;
    if ($[49] !== tiers) {
      t17 = row => <ServiceCatalogRow key={row.id} label={row.title} sublabel={row.description ?? undefined} values={buildServiceValues(row.id, tiers)} metrics={buildServiceMetrics(row.id, tiers)} />;
      $[49] = tiers;
      $[50] = t17;
    } else {
      t17 = $[50];
    }
    t1 = rowBody.map(t17);
    $[0] = billingPeriod;
    $[1] = section;
    $[2] = servicesData.services;
    $[3] = setOptionGroupSelected;
    $[4] = setupDiscountedPrices;
    $[5] = storeOptionGroups;
    $[6] = tier;
    $[7] = tiers;
    $[8] = T0;
    $[9] = T1;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    T0 = $[8];
    T1 = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
  }
  let t4;
  if ($[51] !== T0 || $[52] !== t1) {
    t4 = <T0>{t1}</T0>;
    $[51] = T0;
    $[52] = t1;
    $[53] = t4;
  } else {
    t4 = $[53];
  }
  let t5;
  if ($[54] !== T1 || $[55] !== t2 || $[56] !== t3 || $[57] !== t4) {
    t5 = <T1 isEnabled={t2}>{t3}{t4}</T1>;
    $[54] = T1;
    $[55] = t2;
    $[56] = t3;
    $[57] = t4;
    $[58] = t5;
  } else {
    t5 = $[58];
  }
  return t5;
}
export { OptionGroupSection };